import lazyLoadView from "@router/lazyload-view";
import routeError from "./route-error";

import routersBrand from "@router/routes-brand";
// import routersSolution from "@router/routes-solution";
import routersProduct from "@router/routes-product";
import routersEvent from "@router/routes-event";
import routersAbout from "@router/routes-about";
import routersElite from "./routes-elite";
import routersNews from "@router/routes-news";
import routerVideo from "@router/routes-video";
import routerApply from "@router/routes-apply";
import routersInfo from "@router/routes-info";
import routersService from "@router/routes-service";
import routersContact from "@router/routes-contact";
import routerDealer from '@router/routes-dealer';
import routesTechInside from "./routes-techInside";
import routersLogin from "@router/routes-login";
import routersMember from "@router/routes-member";

import store from '@src/store'

export default [
  // 404
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    meta: {
      showBreadcrumb: false,
      title: '404',
    },
    props: true,
  },
  // 首頁
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/Home/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('global/fetchSetting', "zh-Tw")
          const items = await store.dispatch('global/fetchHome')
          routeTo.params.module = items
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "index",
      title: '首頁',
    },
    props: (route) => ({
      module: route.params.module,
    }),
  },
  {
    path: '/zh-TW',
    redirect: '/'
  },
  {
    path: '/en',
    name: 'en',
    component: () => lazyLoadView(import('@views/En/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
          try {
            await store.dispatch('global/fetchSetting', "en")
            const {
              filterClass = '',
              query = undefined,
            } = routeTo.query
            const params = {
              product_category_alias : filterClass.length
                ? filterClass.split(',')
                : undefined,
              search: query,
            }
            const items = await store.dispatch('global/fetchHome')
            routeTo.params.module = items
            const [
              currentBrandList,
            ] = await Promise.all([
              store.dispatch('brand/fetchBrands', {
                params
              }),
            ])
            routeTo.params.currentBrandList = currentBrandList;
            routeTo.params.currentBrandList.forEach((item) => {
              item.showTxt = false
            })
            const aboutList  = await store.dispatch('about/fetchAbout')
            routeTo.params.aboutCompany = aboutList.company
            next()
          } catch(error) {
            routeError(error, routeTo, next({ name: '404' }));
          }
      },
      alias: "en",
      title: 'Zerone Tech.'
    },
    props: (route) => ({
      module: route.params.module,
      currentBrandList: route.params.currentBrandList,
      aboutCompany: route.params.aboutCompany,
    }),
  },
  // 站內搜尋
  {
    path: '/search/',
    name: 'search',
    component: () => lazyLoadView(import('@views/Search/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { tag, query, page = 1, filterClass = '' } = routeTo.query
          const params = {
            search: query || '',
            type: filterClass.length
              ? filterClass.split(',')
              : [],
            tag: tag || undefined,
            limit: 10,
            page,
          }
          const { items, pagination } = await store.dispatch('global/searchArticle', {
            ...params
          })
          routeTo.params.list = items
          routeTo.params.pagination = pagination
          routeTo.params.page = +page
          // if(routeTo.params.tagTitle) { routeTo.params.breadcrumbTitle = `關鍵字：${ routeTo.params.tagTitle }` };

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '站內搜尋',
    },
    props: (route) => ({
      list: route.params.list,
      pagination: route.params.pagination,
      page: route.params.page,
    }),
  },

  // 關鍵字
  /* {
    path: '/keyword/:tagTitle',
    name: 'keyword',
    component: () => lazyLoadView(import('@views/Keyword/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { categoryAlias, tagAlias, query, page = 1, } = routeTo.query
          const type = categoryAlias
            ? categoryAlias === '*'
              ? undefined
              : categoryAlias
            : undefined

          const { items, pagination } = await store.dispatch('global/searchArticle', {
            search: query || '',
            type,
            tag: tagAlias || undefined,
            limit: 10,
            page,
          })
          routeTo.params.list = items
          routeTo.params.pagination = pagination
          routeTo.params.page = +page
          routeTo.params.breadcrumbTitle = `關鍵字：${ routeTo.params.tagTitle }`;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      }
    },
    props: (route) => ({
      list: route.params.list,
      pagination: route.params.pagination,
      page: route.params.page,
    }),
  }, */
  // 媒體
  {
    path: '/media/:mediaUuid',
    name: 'media',
    component: () => lazyLoadView(import('@views/Media/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      isDisplayFbChat: false
    }
  },
  // 問卷調查
  /* {
    path: '/questionnaire',
    name: 'questionnaire',
    component: () => lazyLoadView(import('@views/Questionnaire/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          routeTo.params.breadcrumbTitle = '問卷調查';

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      }
    }
  }, */
  // Style Guide
  // {
  //   path: '/style-guide',
  //   name: 'style-guide',
  //   component: () => lazyLoadView(import('@views/StyleGuide/Index')),
  // },
  ...routersBrand,
  // ...routersSolution,
  ...routersProduct,
  ...routersEvent,
  ...routersAbout,
  ...routersElite,
  ...routersNews,
  ...routerVideo,
  ...routersInfo,
  ...routersService,
  ...routersContact,
  ...routerApply,
  ...routersLogin,
  ...routersMember,
  ...routerDealer,
  ...routesTechInside,
  {
    path: '*',
    redirect: '404',
  },
]
